import React, { useMemo } from 'react';
import { GoogleMap, DirectionsRenderer } from '@react-google-maps/api';
import { Box } from '@chakra-ui/react';
import { useCustomTheme } from '../contexts/CustomThemeContext'; // ✅ adjust path if needed

interface MapDisplayProps {
    directions: google.maps.DirectionsResult | null;
    center: { lat: number; lng: number; };
    height?: string;
}

const darkMapStyles: google.maps.MapTypeStyle[] = [
    { elementType: "geometry", stylers: [{ color: "#111827" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#0b1220" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#94a3b8" }] },
    {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ color: "#334155" }],
    },
    {
        featureType: "road",
        elementType: "geometry.stroke",
        stylers: [{ color: "#0f172a" }],
    },
    {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [{ color: "#cbd5e1" }],
    },
    {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [{ color: "#9ca3af" }],
    },
    {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ color: "#132a1d" }],
    },
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#0b1220" }],
    },
    {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [{ color: "#93c5fd" }],
    },
];

const MapDisplay: React.FC<MapDisplayProps> = ({ directions, center, height = '500px' }) => {
    const { theme } = useCustomTheme();

    const containerStyle = {
        width: '100%',
        height,
    };

    const mapStyles = useMemo(
        () => (theme.name === "dark" ? darkMapStyles : []),
        [theme.name]
    );

    return (
        <Box
            overflow="hidden"
            borderRadius="xl"
            border="1px solid"
            borderColor={theme.border}
            boxShadow={theme.shadowSm}
            bg={theme.surfaceAlt}
        >
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={10}
                options={{
                    styles: mapStyles,
                    backgroundColor: theme.name === "dark" ? "#111827" : "#ffffff",
                    disableDefaultUI: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                    fullscreenControl: false,
                }}
            >
                {directions && <DirectionsRenderer directions={directions} />}
            </GoogleMap>
        </Box>
    );
};

export default MapDisplay;